import React from 'react'

const HeatMapAbout = () => {
    return (
        <div className="container text-muted">
            <div className="section">
                <div className="content mt-2 mb-8">
                    <h2 className='text-primary text-base font-bold mb-5'>What is Heat Map?</h2>
                    <p>Heatmaps visually represent data using color intensity. Warmer colors indicate higher values, cooler colors indicate lower values.</p>
                    <p>Widely used in data analysis, market research and user experience design. Helpful for spotting trends and making informed decisions. </p>
                </div>
            </div>
            <div className="section">
                <div className="content mt-2 mb-5">
                    <h2 className='text-primary text-base font-bold mb-5'>What is 3x3 Heat Map?</h2>
                    <div className='flex '>
                        <div className="image-container mb-5 md:mb-0 md:mr-10">
                            <img src={'/Common/Icon/heatmap3x3.svg'} alt="3x3 Heat map"/>
                        </div>
                        <ul className='list-disc mt-2 ml-0 md:ml-10'>
                            <li className='mt-2 mb-2'> A 3x3 heat map is a visual tool for prioritizing tasks or items.</li>
                            <li className='mt-2 mb-2' > Its a straightforward method to highlight urgent tasks and identify areas requiring attention.</li>
                            <li className='mt-2 mb-2'> In this map, red signifies high priority, Yellow denotes the Medium priority, while green denotes low priority.</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div className="section">
                <div className="content mb-5">
                    <h2 className='text-primary text-base font-bold mb-5'>What is 5x5 Heat Map?</h2>
                    <div className='flex justify-around'>
                        <div className="image-container mb-5 md:mb-0 md:mr-10">
                            <img src={'/Common/Icon/heatmap5x5.svg'} alt="5x5 Heat map" style={{ width: '326px', height: 'auto' }} />
                        </div>
                        <div>
                            <ul className='list-disc mt-2 ml-0 md:ml-10' >
                                <li className='mt-2 mb-2'> 5x5 Heat Map: Utilizes a color-coded grid to prioritize tasks/items based on importance and urgency.</li>
                                <li className='mt-2 mb-2'> Red for High Priority, Green for Low Priority: Quickly identifies critical tasks (red) and less urgent ones (green).</li>
                                <li className='mt-2 mb-2'> Detailed View, Efficient Resource Allocation: Offers a comprehensive view with five rows and columns, aiding in efficient resource allocation by highlighting areas needing immediate attention and those that can be addressed later.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HeatMapAbout
